'use client'

import { Button, Cell } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  handleClose: () => void
}

const CloseButton = ({ handleClose }: Props) => {
  const translate = useTranslate('seller_protection_dialog.actions')

  return (
    <Cell
      body={
        <Button
          text={translate('close')}
          styling="filled"
          onClick={handleClose}
          testId="seller-protection-dialog-close"
        />
      }
    />
  )
}

export default CloseButton
